module.exports = __webpack_public_path__ + "static/media/ice10.5809626c.webp";